import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Help from '@/components/Help/Help';
import NotificationComponent from '@/components/Notification/NotificationComponent';
import Popup from '@/components/Popup';
import UserActions from '@/redux/UserActions';
import BASIC_CONSTANT from '@/constants/basic.constants.js/basic.constants.js';

const isServer = typeof window === 'undefined';
const WOW = !isServer ? require('wow.js') : null;

function Layout({ children, UserRedux, updateUser, updateChannelUser }) {
  const [notice, setNotice] = React.useState();
  const [version, setVersion] = React.useState('');
  const router = useRouter();
  const channelId = router.query.channelId;

  // Initialize authentication from localStorage
  useEffect(() => {
    new WOW().init();
    const v = localStorage.getItem('version');
    if (v) setVersion(v);

    // Load user from localStorage if not already in Redux
    if (!UserRedux?.user) {
      const token = localStorage.getItem(BASIC_CONSTANT.USER_TOKEN_KEY);
      if (token) {
        updateUser(token);
        document.cookie = `${BASIC_CONSTANT.USER_TOKEN_KEY}=${token}; domain=bgms.live; path=/`;
      }
    }
  }, [UserRedux?.user, updateUser]);

  // Update channel user when channelId changes in URL
  useEffect(() => {
    const token = localStorage.getItem(BASIC_CONSTANT.USER_TOKEN_KEY);
    if (!token || !channelId) return;

    // Skip if already loaded for this channel
    const currentChannelId = UserRedux?.channelUser?.channelId;
    if (currentChannelId === channelId) return;

    updateChannelUser(token, channelId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelId]);

  const handleNotice = data => setNotice(data);

  const getVersion = v => {
    setVersion(v);
    localStorage.setItem('version', JSON.stringify(v));
  };

  return (
    <>
      <ToastContainer transition={Flip} />
      <Header />

      <div className="relative z-[2] pt-16 pb-[200px] min-h-[calc(100%-474px)] bg-black-10 max-[650px]:pb-0 max-[650px]:mb-[100px] max-[650px]:min-h-[calc(100%-329px)] max-[414px]:min-h-[calc(100%-524px)]">
        {/* <Banner /> */}
        {children}
      </div>
      <NotificationComponent type="notice" getNoti={data => handleNotice(data)} />
      {!version && <NotificationComponent type="version" getNoti={data => getVersion(data)} />}
      <Popup notice={notice} />
      <Help />
      <Footer />
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  UserRedux: PropTypes.object,
  updateUser: PropTypes.func,
  updateChannelUser: PropTypes.func,
};

export default connect(
  state => state,
  (dispatch, ownProps) => ({ ...UserActions(dispatch, ownProps) })
)(Layout);
